import { useState } from 'react';

import { ChevronDown, LanguagesIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { get_language_setting } from '@/utils/translations';
import { errorlog } from '@/libs/error-logs';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuCheckboxItem,
} from './ui/dropdown-menu';
import { SidebarMenuButton } from './ui/sidebar';

type LanguageSwitcherProps = {
  isSideBar?: boolean;
};

export const LanguageSwitcher = ({ isSideBar = false }: LanguageSwitcherProps) => {
  const [language, setLanguage] = useState(get_language_setting());
  const { i18n } = useTranslation();

  const handleChangeLanguage = (newLang?: string) => {
    if (!newLang) return;

    i18n
      .changeLanguage(newLang)
      .then(() => {
        setLanguage(newLang);
      })
      .catch((error) => {
        errorlog(error as Error, 'src/components/language-switcher.tsx', 'Error changing language');
      });
  };

  if (isSideBar) {
    // This should to be used in the sidebar
    return (
      <DropdownMenuSub>
        <DropdownMenuSubTrigger asChild>
          <SidebarMenuButton className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground">
            <LanguagesIcon />
            Change Language
          </SidebarMenuButton>
        </DropdownMenuSubTrigger>
        <DropdownMenuSubContent sideOffset={8}>
          <DropdownMenuCheckboxItem
            checked={language === 'en'}
            onCheckedChange={() => handleChangeLanguage('en')}
          >
            English
          </DropdownMenuCheckboxItem>
          <DropdownMenuCheckboxItem
            checked={language === 'es'}
            onCheckedChange={() => handleChangeLanguage('es')}
          >
            Español
          </DropdownMenuCheckboxItem>
        </DropdownMenuSubContent>
      </DropdownMenuSub>
    );
  }
  return (
    <div className="absolute top-2 right-4">
      <DropdownMenu>
        <DropdownMenuTrigger className="flex items-center gap-2 bg-white dark:bg-background rounded-md border p-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50">
          <LanguagesIcon className="h-4 w-4" style={{ color: '#8cc3e1' }} />
          <span>{language.toUpperCase()}</span>
          <ChevronDown className="h-5 w-5 text-gray-400 sm:h-4 sm:w-4" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" side="bottom" sideOffset={4}>
          <DropdownMenuCheckboxItem
            checked={language === 'en'}
            onCheckedChange={() => handleChangeLanguage('en')}
          >
            English
          </DropdownMenuCheckboxItem>
          <DropdownMenuCheckboxItem
            checked={language === 'es'}
            onCheckedChange={() => handleChangeLanguage('es')}
          >
            Español
          </DropdownMenuCheckboxItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
